module.exports = __webpack_public_path__ + "static/media/smile_grac.faa69cdc.png";